import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0c08c30e = () => interopDefault(import('..\\pages\\enroll-complete.vue' /* webpackChunkName: "pages_enroll-complete" */))
const _365d23d4 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _206f7c0f = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _7ef0f993 = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _f91ba3da = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _29e0ea04 = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _1719f880 = () => interopDefault(import('..\\pages\\not-eligible-insurance.vue' /* webpackChunkName: "pages_not-eligible-insurance" */))
const _af14d6d2 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _576cf6e8 = () => interopDefault(import('..\\pages\\returning-user.vue' /* webpackChunkName: "pages_returning-user" */))
const _44b213d8 = () => interopDefault(import('..\\pages\\sms-terms-conditions.vue' /* webpackChunkName: "pages_sms-terms-conditions" */))
const _4e5a01d6 = () => interopDefault(import('..\\pages\\terms-and-conditions.vue' /* webpackChunkName: "pages_terms-and-conditions" */))
const _233cd126 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _7d026c42 = () => interopDefault(import('..\\pages\\unsubscribe.vue' /* webpackChunkName: "pages_unsubscribe" */))
const _bb883d18 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _66302adb = () => interopDefault(import('..\\pages\\voucher-lookup.vue' /* webpackChunkName: "pages_voucher-lookup" */))
const _3f6f0392 = () => interopDefault(import('..\\pages\\voucher-not-found.vue' /* webpackChunkName: "pages_voucher-not-found" */))
const _9812d31c = () => interopDefault(import('..\\pages\\voucher-success.vue' /* webpackChunkName: "pages_voucher-success" */))
const _3bc9366e = () => interopDefault(import('..\\pages\\enroll\\before-you-start.vue' /* webpackChunkName: "pages_enroll_before-you-start" */))
const _08380335 = () => interopDefault(import('..\\pages\\enroll\\eligibility.vue' /* webpackChunkName: "pages_enroll_eligibility" */))
const _8bf475fa = () => interopDefault(import('..\\pages\\enroll\\guardian-required.vue' /* webpackChunkName: "pages_enroll_guardian-required" */))
const _4324ff78 = () => interopDefault(import('..\\pages\\enroll\\HIPAA-consent.vue' /* webpackChunkName: "pages_enroll_HIPAA-consent" */))
const _867e42e8 = () => interopDefault(import('..\\pages\\enroll\\patient-information.vue' /* webpackChunkName: "pages_enroll_patient-information" */))
const _7917250c = () => interopDefault(import('..\\pages\\enroll\\prescriber-information.vue' /* webpackChunkName: "pages_enroll_prescriber-information" */))
const _6874217e = () => interopDefault(import('..\\pages\\enroll\\select-path.vue' /* webpackChunkName: "pages_enroll_select-path" */))
const _66c5fcab = () => interopDefault(import('..\\pages\\enroll\\success.vue' /* webpackChunkName: "pages_enroll_success" */))
const _d4858792 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _d4695890 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _d430fa8c = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _d414cb8a = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _6ab91110 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _2070ffca = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _b3dd44b6 = () => interopDefault(import('..\\pages\\upload-documents\\success.vue' /* webpackChunkName: "pages_upload-documents_success" */))
const _4c1c623e = () => interopDefault(import('..\\pages\\upload-documents\\upload-unsuccessful.vue' /* webpackChunkName: "pages_upload-documents_upload-unsuccessful" */))
const _bde96040 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/enroll-complete",
    component: _0c08c30e,
    name: "enroll-complete"
  }, {
    path: "/error",
    component: _365d23d4,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _206f7c0f,
    children: [{
      path: "",
      component: _7ef0f993,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _f91ba3da,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _29e0ea04,
      name: "have-a-card-success"
    }]
  }, {
    path: "/not-eligible-insurance",
    component: _1719f880,
    name: "not-eligible-insurance"
  }, {
    path: "/rejection",
    component: _af14d6d2,
    name: "rejection"
  }, {
    path: "/returning-user",
    component: _576cf6e8,
    name: "returning-user"
  }, {
    path: "/sms-terms-conditions",
    component: _44b213d8,
    name: "sms-terms-conditions"
  }, {
    path: "/terms-and-conditions",
    component: _4e5a01d6,
    name: "terms-and-conditions"
  }, {
    path: "/unlock",
    component: _233cd126,
    name: "unlock"
  }, {
    path: "/unsubscribe",
    component: _7d026c42,
    name: "unsubscribe"
  }, {
    path: "/upload-documents",
    component: _bb883d18,
    name: "upload-documents"
  }, {
    path: "/voucher-lookup",
    component: _66302adb,
    name: "voucher-lookup"
  }, {
    path: "/voucher-not-found",
    component: _3f6f0392,
    name: "voucher-not-found"
  }, {
    path: "/voucher-success",
    component: _9812d31c,
    name: "voucher-success"
  }, {
    path: "/enroll/before-you-start",
    component: _3bc9366e,
    name: "enroll-before-you-start"
  }, {
    path: "/enroll/eligibility",
    component: _08380335,
    name: "enroll-eligibility"
  }, {
    path: "/enroll/guardian-required",
    component: _8bf475fa,
    name: "enroll-guardian-required"
  }, {
    path: "/enroll/HIPAA-consent",
    component: _4324ff78,
    name: "enroll-HIPAA-consent"
  }, {
    path: "/enroll/patient-information",
    component: _867e42e8,
    name: "enroll-patient-information"
  }, {
    path: "/enroll/prescriber-information",
    component: _7917250c,
    name: "enroll-prescriber-information"
  }, {
    path: "/enroll/select-path",
    component: _6874217e,
    name: "enroll-select-path"
  }, {
    path: "/enroll/success",
    component: _66c5fcab,
    name: "enroll-success"
  }, {
    path: "/errors/400",
    component: _d4858792,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _d4695890,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _d430fa8c,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _d414cb8a,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _6ab91110,
    name: "errors-500"
  }, {
    path: "/patient/patientSearch",
    component: _2070ffca,
    name: "patient-patientSearch"
  }, {
    path: "/upload-documents/success",
    component: _b3dd44b6,
    name: "upload-documents-success"
  }, {
    path: "/upload-documents/upload-unsuccessful",
    component: _4c1c623e,
    name: "upload-documents-upload-unsuccessful"
  }, {
    path: "/",
    component: _bde96040,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
